import { Component, Input } from '@angular/core'
import { MatProgressSpinner } from '@angular/material/progress-spinner'

@Component({
  selector: 'app-spinner',
  standalone: true,
  imports: [MatProgressSpinner],
  templateUrl: './spinner.component.html',
  styleUrl: './spinner.component.scss',
})
export class SpinnerComponent {
  @Input()
  size: 'small' | 'medium' | 'big' = 'big'

  get spinnerSize(): number {
    switch (this.size) {
      case 'small':
        return 12
      case 'medium':
        return 36
      case 'big':
        return 96
      default:
        return 36
    }
  }
}
